<template>
    <div class="container" v-if="caseMessageInfo.length>0">
        <div class="item-headder">
            <div>
                <h2>{{baseToText(caseInfo.subject)}}</h2>
                <p>#{{caseInfo.caseid}}</p>
            </div>
        </div>
        <!--<p>{{caseInfo}}</p>-->
        <div class="case-content-split">
            <div class="message-details">
                <div class="title">
                    <h3>Details</h3>
                    <div class="btn sm" v-if="!editDetails" v-on:click="UpdatebackupDetails()">Edit</div>
                </div>
                <div v-if="!editDetails">
                    <div class="div-table row">
                        <div>
                            <p>Status</p>
                            <span class="status">
                                <div class="pill xl green" v-if="caseInfo.status == 'agent_waiting'">Awating customer</div>
                                <div class="pill xl red" v-if="caseInfo.status == 'hold'">Awaiting specific supporter</div>
                                <div class="pill xl" v-if="caseInfo.status == 'closed'">Closed</div>
                                <div class="pill xl red" v-if="caseInfo.status == 'client_waiting'">Awating supporter</div>
                                <div class="pill xl" v-if="caseInfo.status == 'archived'">Archived</div>
                                <div class="pill xl green" v-if="caseInfo.status == 'active'">Active</div>
                            </span>
                        </div>
                        <div>
                            <p>Department</p>
                            <span>{{caseInfo.title}}</span>
                        </div>
                        <router-link tag="div" class="clickable" :to="'/customers/' + caseMessageInfo[0].userinfo.id">
                            <p>Creator</p>
                            <span>{{caseMessageInfo[0].userinfo.name}}<div class="pill" :class="{'main' : (caseMessageInfo[0].type == 'CLIENT'), 'green' : (caseMessageInfo[0].type == 'AGENT')}">{{caseMessageInfo[0].type}}</div></span>
                        </router-link>
                        <div>
                            <p>Created</p>
                            <span>{{dateTimeFormat(caseInfo.creation)}}</span>
                        </div>
                        <router-link tag="div" class="clickable" :to="'/customers/' + caseMessageInfo[caseMessageInfo.length -1].userinfo.id">
                            <p>Last Reply</p>
                            <span>{{caseMessageInfo[caseMessageInfo.length -1].userinfo.name}}<div class="pill" :class="{'main' : (caseMessageInfo[caseMessageInfo.length -1].type == 'CLIENT'), 'green' : (caseMessageInfo[caseMessageInfo.length -1].type == 'AGENT')}">{{caseMessageInfo[caseMessageInfo.length -1].type}}</div></span>
                        </router-link>
                        <div>
                            <p>Last Update</p>
                            <span>{{dateTimeFormat(caseMessageInfo[caseMessageInfo.length -1].creation)}}</span>
                        </div>
                        <router-link tag="div" class="clickable" :to="'/products/' + caseInfo.product" v-if="caseInfo.product">
                            <p>Product</p>
                            <span>{{caseInfo.product}}</span>
                        </router-link>
                        <router-link v-if="caseInfo.assigneeinfo" tag="div" class="clickable" :to="'/customers/' + caseInfo.assigneeinfo.id">
                            <p>Assignee</p>
                            <span>{{caseInfo.assigneeinfo.name}}<div class="pill green">AGENT</div></span>
                        </router-link>
                    </div>
                    <div class="action-panel">
                        <div class="btn" v-on:click="smsmodal = 1">Remind customer via SMS</div>
                        <div class="btn" v-on:click="sendMail()">Remind customer via Mail</div>
                    </div>
                </div>
                <div v-else>
                    <div class="div-table row">
                    <div>
                        <p>Status</p>
                        <span>
                            <select v-model="caseInfo.status">
                                <option value="agent_waiting">Awating customer</option>
                                <option :disabled="caseInfo.assignee <= 0" value="hold">Awaiting specific supporter</option>
                                <option value="closed">Closed</option>
                                <option value="client_waiting">Awating supporter</option>
                                <option value="archived">Archived</option>
                                <option value="active">Active</option>
                            </select>
                        </span>
                    </div>
                    <div>
                        <p>Department</p>
                        <span>
                            <select v-model="caseInfo.department">
                                <option v-for="department in departments" :value="department.id" :key="department.id">
                                    {{department.title}}
                                </option>
                            </select>
                        </span>
                    </div>
                    <div>
                        <p>Product</p>
                        <span>
                            <select v-model="caseInfo.product">
                                <option value="">No product</option>
                                <option v-for="userproduct in userproducts" :value="userproduct.supportid" :key="userproduct.supportid">
                                    {{userproduct.supportid}} - {{userproduct.description}}
                                </option>
                            </select>
                        </span>
                    </div>
                    <div>
                        <p>Assignee</p>
                        <span>
                            <select v-model="caseInfo.assignee">
                                <option :value="null">No assignee</option>
                                <option v-for="assignee in assignees" :value="assignee.id" :key="assignee.id">
                                    {{assignee.name}}
                                </option>
                            </select>
                        </span>
                    </div>
                </div>
                    <div class="action-panel">
                        <div class="btn" v-on:click="CancelDetailChange()">Cancel</div>
                        <div class="btn" v-on:click="saveCase()">Save</div>
                    </div>
                </div>
            </div>
                        
            <div class="message-thread">
                <div class="new-message">
                    <p class="message-content" id="message-content" contenteditable="true" placeholder="Write a new message..."></p>
                    <div class="action-panel">
                        <select class="btn" v-model="answer.type">
                            <option disabled selected value="">Select an action</option>
                            <option value="closed">Reply and close</option>
                            <option value="agent_waiting">Reply and await client response</option>
                        </select>
                        <div class="btn" v-on:click="answerCase()">Send</div>
                    </div>
                </div>

                <div class="messages">
                    <div v-for="case_msg in caseMessageInfo" :key="case_msg.id" :class="{'agent' : (case_msg.type == 'AGENT')}">
                        <div class="message-title">
                            <router-link tag="div" class="clickable" :to="'/customers/' + case_msg.userinfo.id">
                                <v-gravatar class="profile-image" :size="200" :email="case_msg.userinfo.email" />
                                <span>{{case_msg.userinfo.name}}</span>
                                <span class="pill xl" :class="{'main' : (case_msg.type == 'CLIENT'), 'green' : (case_msg.type == 'AGENT')}">{{case_msg.type}}</span>
                            </router-link>
                            <div>
                                <span class="timestamp">{{dateTimeFormat(case_msg.creation)}}</span>
                            </div>
                        </div>                
                        <p class="message-content" v-html="baseToText(case_msg.message)"></p>

                        <p class="sender-details">{{case_msg.ip}}<span class="message-id"> - #{{case_msg.id}}</span></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" v-if="smsmodal == 1">
            <div class="modal-body">
                <h3>Send SMS</h3>
                <p>Are you sure you wish to send an SMS to the customer {{caseInfo.userinfo.name}}?</p>
                <p>His number is {{caseInfo.userinfo.phone}}.</p>
                <div class="action-panel">
                    <div class="btn" v-on:click="smsmodal = 0">Cancel</div>
                    <div class="btn main" v-on:click="sendSMS(caseInfo.userinfo.phone)">Yes</div>
                </div>
            </div>
        </div>
    </div>
    <Loading v-else/>
</template>
<style scoped lang="scss">
    .case-content-split{
        display: flex;
        .message-details{
            width: 370px;
            max-width: 100%;
            margin: 0 2rem 0 0;
            flex-shrink: 0;
            height: max-content;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
            .title{
                padding: 1rem;
                display: flex;
                justify-content: space-between;
            }
            h3{
                margin-bottom: 1rem;
            }
            .div-table{
                margin-top: 0;
            }
            .status .pill{
                margin:-5px 0;
            }
            .action-panel{
                padding: 0 1rem 1rem 1rem;
            }
        }
        .message-thread{
            flex-grow: 2;
            flex-shrink: 2;
        }
        @media(max-width: 1000px){
            flex-direction: column;
            &>div{
                &:first-child{
                    margin: 0 0 4rem 0;
                    width: 100%;
                }
            }
        }
    }
    .new-message{
        border-radius: 5px;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        padding: 1.5rem;
        background-color: var(--bg-color-3);
        transition: background-color 300ms ease, box-shadow 300ms ease;
        &:hover, &:focus, &:focus-within{
            background-color: var(--bg-color-4);
            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
        }
        margin-bottom: 3rem;
        .message-content{
            min-height: 3rem;
            margin-top: 0;
        }
        .action-panel{
            margin-top: 1rem;
            border-top: 1px solid rgba(gray, 0.4);
            padding-top: 10px;
        }
    }

    .messages{
        display: flex;
        flex-direction: column-reverse;
        &:not(:empty){
            margin-bottom: -1rem;
        }
        &>div{
            margin-bottom: 1rem;
            border-radius: 5px;
            box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
            padding: 1.5rem;
            background-color: var(--bg-color-2);
            &.agent{
                background-color: var(--bg-color-3);
            }
            .message-title{
                border-bottom: 1px solid rgba(gray, 0.4);
                margin-bottom: 1rem;
                padding-bottom: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &>div{
                    display: flex;
                    align-items: center;
                }
                .profile-image{
                    height: 45px;
                    width: 45px;
                    border-radius: 50%;
                    margin-right: 1rem;
                    object-fit: cover;
                    background-color: rgba(gray, 0.4);
                    flex-shrink: 0;
                }
                .pill{
                    margin-left: 10px;
                }
                .timestamp{
                    opacity: 0.8;
                    font-size: 0.8rem;

                }
            }
            .message-content{
                opacity: 0.9;
                white-space: pre;
            }
            .sender-details{
                font-size: 0.8rem;
                .message-id{
                    opacity: 0.6;
                }
            }

        }
    }
</style>
<script>
import Loading from '@/components/parts/Loading.vue'

export default {
    name: 'Case',
    components: {
    Loading
    },
    data() {
        return {
            caseInfo: {},
            caseMessageInfo: [],
            editDetails: 0,
            answer: {
                message: '',
                type: '',
            },
            backupDetails: {
                status: null,
                department: null,
                product: null,
                assignee: null,
            },
            departments: [],
            assignees: [],
            userproducts: [],
            smsmodal: 0,

        }
    },
    methods: {
        withBrTags: function(data) {
            return data.replace(/(\\r)*\\n/g, '<br>')
        },
        baseToText(base){
            return atob(base);
        },
        sendSMS(number){
            var message = 'remindCase';
            this.$socket.client.emit('sendMessage',{number: number, message: message}, (error, response) => {
                this.smsmodal = 0;
                if(error == 200){
                    document.getElementById("Toast1").classList.remove("red");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("green");
                    document.getElementById("Toast1").innerText = "SMS sent";
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                }else{
                    document.getElementById("Toast1").classList.remove("green");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("red");
                    document.getElementById("Toast1").innerText = "Could not send message. Error: " + response;
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                }
            })
        },
        sendMail(){
            this.$socket.client.emit('sendEmail',null, (error, response) => {
                if(error == 200){
                    document.getElementById("Toast1").classList.remove("red");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("green");
                    document.getElementById("Toast1").innerText = "SMS sent";
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                }else{
                    document.getElementById("Toast1").classList.remove("green");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("red");
                    document.getElementById("Toast1").innerText = "Could not send mail. Error: " + response;
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                }
            })
        },
        saveCase(){
            var vue = this;
            var assignename;
            if(vue.caseInfo.assignee!=null){
                assignename = vue.formatName(vue.assignees.filter(dat=>{ return dat.id == vue.caseInfo.assignee; })[0].name);
            }else{
                assignename = null;
            }
            this.editDetails = 0;
                this.$socket.client.emit('editCase',
                {titles: 
                    {
                        user: assignename,
                        department: vue.departments.filter(dat=>{ return dat.id == vue.caseInfo.department; })[0].title,
                        supportid: vue.caseInfo.product}
                    ,old: vue.backupDetails, caseid: vue.caseInfo.id,department: vue.caseInfo.department, status: vue.caseInfo.status, product: vue.caseInfo.product,assignee: vue.caseInfo.assignee}, (error, response) => {
                if(error == 200){
                    document.getElementById("Toast1").classList.remove("red");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("green");
                    document.getElementById("Toast1").innerText = "The changes was saved";
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                    vue.getCaseData();
                }else{
                    document.getElementById("Toast1").classList.remove("green");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("red");
                    document.getElementById("Toast1").innerText = "Could not save changes. Error: " + response;
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                }
            })
        },
        answerCase(){
            var vue = this;
            var message = document.getElementById("message-content").innerText;
            if(this.answer.type && message){
                this.$socket.client.emit('answerCase',{caseid: vue.caseInfo.id, message: message, sender: this.formatName(this.$store.state.account.name), answertype: this.answer.type}, (error, response) => {
                if(error == 200){
                    document.getElementById("Toast1").classList.remove("red");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("green");
                    document.getElementById("Toast1").innerText = "Message sent";
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                    vue.getCaseData();
                    document.getElementById("message-content").innerText='';

                }else{
                    document.getElementById("Toast1").classList.remove("green");
                    document.getElementById("Toast1").classList.remove("hide");
                    document.getElementById("Toast1").classList.add("red");
                    document.getElementById("Toast1").innerText = "Could not send message. Error: " + response;
                    setTimeout(function() {
                        document.getElementById("Toast1").classList.add("hide");
                    }, 3000);
                }
                })
            }
        },
        formatName(name){
            var namearray = name.split(" ");
            return namearray[0] + " " +namearray[namearray.length-1].charAt(0)+'.';
        },
        getCaseData(){
            var vue = this;
            this.$socket.client.emit('getCaseInfo',vue.$route.params.caseid, (error, response) => {
                if(error=='200'){
                    vue.caseInfo = response;
                    
                    vue.$socket.client.emit('getUserProducts',vue.caseInfo.user, (error, response) => {
                        if(error=='200'){
                            vue.userproducts = response;
                        }
                    })
                }
            })
            this.$socket.client.emit('getCaseMessages',vue.$route.params.caseid, (error, response) => {
                if(error=='200'){
                    vue.caseMessageInfo = response;
                }
            })
            this.$socket.client.emit('getCaseDepartments',null, (error, response) => {
                if(error=='200'){
                    vue.departments = response;
                }
            })
            this.$socket.client.emit('getAssigneeCases',null, (error, response) => {
                if(error=='200'){
                    vue.assignees = response;
                }
            })
        },
        dateTimeFormat : function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        },
        CancelDetailChange: function(){
            this.caseInfo.status = this.backupDetails.status;
            this.caseInfo.department = this.backupDetails.department;
            this.caseInfo.product = this.backupDetails.product;
            this.caseInfo.assignee = this.backupDetails.assignee;
            this.editDetails = 0;
        },
        UpdatebackupDetails: function(){
            this.backupDetails.status = this.caseInfo.status;
            this.backupDetails.department = this.caseInfo.department;
            this.backupDetails.product = this.caseInfo.product;
            this.backupDetails.assignee = this.caseInfo.assignee;
            this.editDetails = 1;
        }
    },
    mounted() {
        this.getCaseData();
    },
}
</script>